import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "user";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const listPeriodeTunsus = "Kepegawaian/RevisiTunjanganKhusus/list/";
export const createPeriodeTunsus = "Kepegawaian/RevisiTunjanganKhusus/create/";
export const listEmployeeTunsus =
  "Kepegawaian/RevisiTunjanganKhusus/employeeList/";
export const listEmployeeDatatable =
  "Kepegawaian/RevisiTunjanganKhusus/employeeListDatatable/";

export const detailPeriodTunsus =
  "Kepegawaian/RevisiTunjanganKhusus/detailPeriod/";

export const detailBobot = "Kepegawaian/RevisiTunjanganKhusus/detailBobot/";

export const addEmployee = "Kepegawaian/RevisiTunjanganKhusus/addEmployee/";
export const exportExcel = "Kepegawaian/RevisiTunjanganKhusus/exportExcel/";
export const detailEmployee =
  "Kepegawaian/RevisiTunjanganKhusus/detailEmployee/";

/// Grade
export const updatePresence =
  "Kepegawaian/RevisiTunjanganKhusus/updatePresence/";
export const updateGrade = "Kepegawaian/RevisiTunjanganKhusus/updateGrade/";
export const updateSkp = "Kepegawaian/RevisiTunjanganKhusus/updateSkp/";
export const updatePenilaian = "Kepegawaian/RevisiTunjanganKhusus/updatePenilaian/";
export const recalculationRevision =
  "Kepegawaian/RevisiTunjanganKhusus/recalculationRevision/";

export const gradeDetail = "Kepegawaian/RevisiTunjanganKhusus/gradeDetail/";
export const gradePositionList =
  "Kepegawaian/RevisiTunjanganKhusus/gradePositionList/";
export const gradeList = "Kepegawaian/RevisiTunjanganKhusus/gradeList/";

/// Grade

export const inactivePeriod =
  "Kepegawaian/RevisiTunjanganKhusus/inactivePeriod/";

export const finishPeriod = "Kepegawaian/RevisiTunjanganKhusus/finishPeriod/";
export const listEmployeeTable =
  "Kepegawaian/RevisiTunjanganKhusus/employeeListTable/";
export const individualcriterialist = "Kepegawaian/SkpTunjanganKhusus/get_individualcritereia/";
export const listComponent =
  "Kepegawaian/PenilaianTunjanganKhusus/listPenilaiain/";
export const listCriteria =
  "Kepegawaian/PenilaianTunjanganKhusus/listCriteria/";// get penilian history
export const listPenilaianBefore =
  "Kepegawaian/PenilaianTunjanganKhusus/listPenilaianBefore/";
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
